export default __webpack_public_path__ + "static/media/hitch_implement.122565db.svg";